import { render, staticRenderFns } from "./sharepoint-folders-modal.vue?vue&type=template&id=1c81a931"
import script from "./sharepoint-folders-modal.vue?vue&type=script&lang=js"
export * from "./sharepoint-folders-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports